/* eslint-disable */
import { useState } from "react";
import {
  Phone,
  PhoneCall,
  Mail,
  MessageCircle,
  HardHat,
  Pencil,
  LogOut,
  Clock,
} from "lucide-react";
import { operationsApi } from "./api";
import RetireStaffDialog from "./RetireStaffDialog";
import EditStaffDialog from "./EditStaffDialog";
import "./StaffCard.css";

function initials(name) {
  return (name || "?")
    .trim()
    .split(/\s+/)
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function telLink(raw) {
  const d = String(raw || "").replace(/\D/g, "").slice(-10);
  return d ? `tel:+91${d}` : "#";
}
function waLink(raw) {
  const d = String(raw || "").replace(/\D/g, "").slice(-10);
  return d ? `https://wa.me/91${d}` : "#";
}

export default function StaffCard({
  member,
  shifts,
  canManage = false,
  onChanged,
  dimmed = false,
  featured = false,
}) {
  const [showRetire, setShowRetire] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const phone = member.phone;
  const canCall = !dimmed && !!phone;

  return (
    <article
      className={`vsop-card ${dimmed ? "dimmed" : ""} ${featured ? "featured" : ""}`}
    >
      <div className="vsop-head-row">
        <div className="vsop-avatar">
          {member.avatar_url ? (
            <img src={member.avatar_url} alt={member.full_name} />
          ) : (
            <span>{initials(member.full_name)}</span>
          )}
        </div>
        <div className="vsop-head-text">
          <h3>{member.full_name}</h3>
          <span className={`vsop-role-pill role-${(member.role || "").toLowerCase()}`}>
            {member.role_label}
          </span>
          {shifts && shifts.length > 0 && (
            <span className="vsop-duty-pill">
              <Clock size={10} /> On duty today
              {shifts.length > 1 ? ` (${shifts.length} shifts)` : ` · ${shifts[0]}`}
            </span>
          )}
        </div>
        {canManage && !dimmed && (
          <div className="vsop-admin-actions">
            <button
              type="button"
              className="vsop-icon-btn"
              onClick={() => setShowEdit(true)}
              aria-label="Edit"
              title="Edit"
            >
              <Pencil size={13} />
            </button>
            <button
              type="button"
              className="vsop-icon-btn"
              onClick={() => setShowRetire(true)}
              aria-label="Retire"
              title="Retire staff member"
            >
              <LogOut size={13} />
            </button>
          </div>
        )}
      </div>

      {member.notes && <p className="vsop-notes">{member.notes}</p>}

      {!dimmed && (
        <div className="vsop-actions">
          <a
            href={telLink(phone)}
            className={`vsop-action ${!canCall ? "disabled" : ""}`}
            aria-disabled={!canCall}
            aria-label="Call"
            title="Call"
          >
            <Phone size={16} />
          </a>
          <a
            href={waLink(phone)}
            target="_blank"
            rel="noreferrer"
            className={`vsop-action vsop-action-wa ${!canCall ? "disabled" : ""}`}
            aria-disabled={!canCall}
            aria-label="WhatsApp"
            title="WhatsApp"
          >
            <MessageCircle size={16} />
          </a>
          {member.alt_phone && (
            <a
              href={telLink(member.alt_phone)}
              className="vsop-action vsop-action-mail"
              aria-label="Call alternate number"
              title="Alternate number"
            >
              <PhoneCall size={16} />
            </a>
          )}
        </div>
      )}

      {dimmed && member.retired_at && (
        <div className="vsop-served">
          <HardHat size={11} /> Retired{" "}
          {new Date(member.retired_at).toLocaleDateString()}
        </div>
      )}

      {showRetire && (
        <RetireStaffDialog
          member={member}
          onClose={() => setShowRetire(false)}
          onRetired={() => {
            setShowRetire(false);
            onChanged && onChanged();
          }}
        />
      )}
      {showEdit && (
        <EditStaffDialog
          member={member}
          onClose={() => setShowEdit(false)}
          onSaved={() => {
            setShowEdit(false);
            onChanged && onChanged();
          }}
        />
      )}
    </article>
  );
}
